import { createConfig, http } from 'wagmi';
import { base } from 'wagmi/chains';
import { Attribution } from 'ox/erc8021';
import { injected } from 'wagmi/connectors';

// Builder Code from base.dev settings
const DATA_SUFFIX = Attribution.toDataSuffix({
  codes: ['bc_6mk85pui'],
});

export const config = createConfig({
  chains: [base],
  connectors: [
    injected(), // MetaMask and other injected wallets
  ],
  transports: {
    [base.id]: http(),
  },
  dataSuffix: DATA_SUFFIX, // Applied globally to all transactions
});
